// @ts-nocheck
export default {
    getterSelectedWorkerList(state, getters, rootState, rootGetters) {
        const getterCheckedWorkerList = rootGetters['workerManagement/workerList/getterCheckedWorkerList'];
        return getterCheckedWorkerList.map(({ code, name, hubName, }) => ({
            workerCode: code,
            workerName: name,
            hubName,
        })) ?? [];
    },
};
